import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import { Link } from "react-router-dom";
import { assets } from "../assets/assets";

const boardMembers = [
  {
    name: "Sanjay Kommera",
    title: "Chief Executive Officer",
    linkedin: "https://www.linkedin.com/in/sanjay-kommera-37574a10/",
    photo: assets.team1,
  },
  {
    name: "Raj Kishor Khaware, Ph.D. (MIT)",
    title: "Co-Founder, Lead Investor, Advisory & Board Member",
    linkedin: "https://www.linkedin.com/in/rajkhaware/",
    photo: assets.team2,
  },
  {
    name: "Vishal Gupta",
    title: "Advisory",
    linkedin: "https://www.linkedin.com/in/vishal-gupta-046149/",
    photo: assets.vishalgupta,
  },
  {
    name: "Noni Gonzalez",
    title: "Advisory & Board Member",
    linkedin: "https://www.linkedin.com/in/noni-gonzalez-0016896/",
    photo: assets.NoniGonzalez,
  },
  {
    name: "Tracy Paddock Beam",
    title: "Advisory & Board Member",
    linkedin: "https://www.linkedin.com/in/tracy-paddock-beam-1a99499/",
    photo: assets.TracyPaddock,
  },
  {
    name: "Jacques Guichard",
    title: "Advisory & Board Member",
    linkedin: "https://www.linkedin.com/in/jacquesguichard/",
    photo: assets.JacquesGuichard,
  },
];

const teamData = [
  {
    name: "Sanjay Kommera",
    title: "Chief Executive Officer",
    location: "Atlanta, USA",
    qualification: "Technology, Strategy, Sustainability",
    linkedin: "https://www.linkedin.com/in/sanjay-kommera-37574a10/",
    description:
      "A tech visionary with 24+ years of experience in integration, data, and analytics, Sanjay leads Accel1 with a deep passion for converging sustainability with frontier technology. His work enables governments and enterprises to decarbonize, optimize systems, and innovate with purpose.",

    photo: assets.team1,
    thumbphoto: assets.thumbteam1,
  },
  {
    name: "Raj Kishor Khaware, Ph.D. (MIT)",
    title: "Co-Founder & Chief Strategy Officer",
    location: "California, USA",
    qualification: "Climate Capital, Systems Thinking, Policy",
    linkedin: "https://www.linkedin.com/in/rajkhaware/",
    description:
      "A former IAS officer, Raj brings decades of leadership across public policy, venture capital, and deep-tech entrepreneurship. With a portfolio of over 21 companies and global investments exceeding $1B, he shapes Accel1’s ecosystem-led strategy with bold, systemic thinking.",
    photo: assets.team2,
    thumbphoto: assets.thumbteam2,
  },

  {
    name: "Wendy N Atlin",
    title: "Chief Growth Officer",
    location: "Beverly Hills, California",
    qualification: "Global Sales and Branding",
    linkedin: "https://www.linkedin.com/in/wendy-n-atlin-1528893/",
    description:
      "A global catalyst for growth and transformation, Wendy leads Accel1’s climate-tech expansion with visionary strategy, bold execution, and an unyielding passion for impact.",
    photo: assets.Wendy,
    thumbphoto: assets.Wendythumb,
  },
  {
    name: "Mark Becking",
    title: "Chief Product Officer & Chief Architect",
    location: "Mississippi, USA",
    qualification: "Platform Architecture, Product Innovation",
    linkedin: "https://www.linkedin.com/in/mark-becking/",
    description:
      "Mark is the brain behind the architecture of AccelTRACK and other core platforms. With a track record of building scalable enterprise platforms, he ensures that Accel1’s products are future-ready, secure, and mission-aligned.",
    photo: assets.team3,
    thumbphoto: assets.thumbteam3,
  },

  {
    name: "Balvinder Mangat",
    title: "Vice President, Delivery Excellence",
    location: "California, USA & India",
    qualification: "Agile, Enterprise Transformation, Women Empowerment",
    linkedin: "",
    description:
      "With over 23 years at Cognizant and Uber, Balvinder leads delivery with precision and empathy. She’s passionate about empowering women leaders and ensuring sustainable execution in complex digital environments.",
    photo: assets.team4,
    thumbphoto: assets.thumbteam4,
  },
  {
    name: "Dr. Sai Bhaskar Reddy Nakka",
    title: "Chief Climate Engineering Officer",
    location: "Hyderabad, India",
    qualification: "Environmental Science, Rural Innovation",
    linkedin: "https://www.linkedin.com/in/sai-bhaskar-reddy-nakka-44888913/",
    description:
      "A global thought leader in sustainable development and disaster risk reduction, Dr. Reddy leads the Climate Engineering Vertical. His expertise spans over 20 years of pioneering work in soil, water, agriculture, and community-led adaptation.",
    photo: assets.team5,
    thumbphoto: assets.thumbteam5,
  },
  {
    name: "Shashank Taman",
    title: "Chief Climate Solutions Officer",
    location: "Hyderabad, India",
    qualification: "Climate Risk, Green Infrastructure, Carbon Strategy",
    linkedin: "https://www.linkedin.com/in/shashanktaman-ind/",
    description:
      "An expert in sustainable infrastructure and energy systems, Shashank drives solution implementation across HydroTRACE, AtmosPAD, and BioFORGE™ verticals. He brings the operational muscle to climate intelligence.",
    photo: assets.team6,
    thumbphoto: assets.thumbteam6,
  },

  {
    name: "Srinivas Ponna",
    title: "Chief Delivery Officer",
    location: "Hyderabad, India",
    qualification: "Consulting, Transformation, Quality",
    linkedin: "https://www.linkedin.com/in/srinivasponna/",
    description:
      "Srinivas brings rigor, global delivery expertise, and operational depth to ensure every engagement delivers measurable value and on-ground impact.",
    photo: assets.team7,
    thumbphoto: assets.thumbteam7,
  },

  {
    name: "Pratibha Chauhan",
    title: "Climate Story Teller",
    location: "Jaipur, Rajasthan",
    qualification: "Sustainability, Science and Story Telling",
    linkedin: "https://www.linkedin.com/in/pratibha-chauhan-780004320/",
    description:
      "A voice for the planet, Pratibha weaves data and humanity into powerful climate narratives that inspire action, shift mindsets, and make sustainability personal.",
    photo: assets.PratibhaChauhan,
    thumbphoto: assets.PratibhaChauhanthumb,
  },
  {
    name: "Terrence Johnson",
    title: "Senior Product Architect",
    location: "South Africa",
    qualification: "System Design, Intelligent Platforms",
    linkedin: "https://www.linkedin.com/in/terrence-johnson-4bbb7a4b/",
    description:
      "A tech builder at heart, Terrence designs the brains behind Accel1’s AI and intelligence layers across platforms.",
    photo: assets.team8,
    thumbphoto: assets.thumbteam8,
  },

  // Add 7 more team members here
];

function Leadership() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentboardMembers = boardMembers[currentIndex];

  const currentMember = teamData[currentIndex];

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % teamData.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + teamData.length) % teamData.length);
  };

  const handleSelect = (index) => {
    setCurrentIndex(index);
  };

  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  return (
    <div>
      <div className="innerbanner-section-1">
        <div className="relative-1">
          <div className="s1-heading-text-new">
            <h1 data-aos="zoom-in">
              Meet the Minds Building Tomorrow’s Climate Infrastructure
            </h1>
            <p data-aos="zoom-in">
              At Accel1, we believe that solving the planet’s toughest
              challenges requires leaders who dream big, act fast, and deliver
              boldly. Our leadership team brings together deep experience from
              enterprise technology, climate science, government, and capital
              markets, united by a single mission: engineering a sustainable
              future at scale.
            </p>
            <p data-aos="zoom-in">We don’t just lead companies.</p>
            <p data-aos="zoom-in">
              We lead movements, systems, and platforms that accelerate impact.
            </p>
          </div>
          <img
            src={assets.leadershipbanner}
            alt=""
            data-aos="fade-in"
            className="d-d"
          />
          <img
            src={assets.leadershipmobilebanner}
            alt=""
            data-aos="fade-in"
            className="m-d"
          />
        </div>
      </div>
      <div className="about-bg-4">
        <div className="wrappe ">
          <div className="flagship-heading">
            <h2>Executive Leadership Team</h2>
          </div>

          {/* Start */}
          <div className="team-section-wrap">
            <div className="team-p-wrap">
              <div className="team-p-1">
                <h3>{currentMember.name}</h3>
              </div>
              <div className="team-p-2">
                <img
                  src={currentMember.photo}
                  alt={currentMember.name}
                  className="main-photo"
                />
              </div>
              <div className="team-p-3">
                <h4>{currentMember.title}</h4>

                <p>
                  <span role="img" aria-label="location">
                    <img src={assets.locationicon} alt="" />
                  </span>
                  {currentMember.location}
                </p>
                <p>
                  <span role="img" aria-label="briefcase">
                    <img src={assets.profileicon} alt="" />
                  </span>
                  <em>{currentMember.qualification}</em>
                </p>
                <div className="line-2"></div>
                <a
                  href={currentMember.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={assets.linkedinicon} alt="" />
                </a>
              </div>
              <div className="team-p-4">{currentMember.description}</div>
            </div>
            <div className="team-container">
              <div className="thumbnail-nav">
                <button onClick={handlePrev} className="arrow left">
                  ←
                </button>
                <div className="thumbnails">
                  {teamData.map((member, index) => (
                    <img
                      key={index}
                      src={member.thumbphoto}
                      alt={member.name}
                      className={`thumb ${
                        index === currentIndex ? "active" : ""
                      }`}
                      onClick={() => handleSelect(index)}
                    />
                  ))}
                </div>
                <button onClick={handleNext} className="arrow right">
                  →
                </button>
              </div>
            </div>
          </div>
          {/* End */}

          <div className=" m-t-1">
            <h2>Board Members</h2>
          </div>
          <div className="board-mem-section">
            {boardMembers.map((boardmember, index) => (
              <div className="board-mem-1">
                <img
                  key={index}
                  src={boardmember.photo}
                  alt={boardmember.name}
                />
                <h4>{boardmember.name}</h4>
                <p>{boardmember.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-section-1 green-bg-5 height-inherit">
        <div className="wrapper">
          <div className="flagship-heading" data-aos="fade-up">
            <h2>Board of Advisors & Global Partners</h2>
            <p>
              Our advisory board includes scientists, public policy experts,
              investors, and former government officials who ensure our
              platforms remain future-aligned, impact-led, and globally
              scalable.
            </p>

            <div className="join-us-wrap">
              <h5>Want to Partner with Us?</h5>
              <p>
                We're always open to collaborating with visionary leaders,
                domain experts, and technologists passionate about solving real
                climate problems.
              </p>
              <a href="mailto:partners@accel1.com" className="button-1">
                partners@accel1.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Leadership;
